export default function CyberActionButton({ variant, label, tag, arcOffset, onClick }) {
  const isBrief = variant === "brief";
  const stroke = isBrief ? "rgba(99,102,241,.7)" : "rgba(245,158,11,.75)";
  const strokeBg = isBrief ? "rgba(99,102,241,.12)" : "rgba(245,158,11,.1)";
  const glow = isBrief ? "drop-shadow(0 0 3px rgba(99,102,241,.6))" : "drop-shadow(0 0 3px rgba(245,158,11,.55))";
  const textFill = isBrief ? "rgba(99,102,241,.75)" : "rgba(245,158,11,.8)";
  const letter = isBrief ? "B" : "I";
  const CIRC = 69.1;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`hud-ta-btn ${isBrief ? "hud-ta-brief" : "hud-ta-hints"}`}
    >
      <svg width="28" height="28" viewBox="0 0 28 28" style={{ flexShrink: 0 }}>
        <circle cx="14" cy="14" r="11" fill="none" stroke={strokeBg} strokeWidth="2" />
        <circle cx="14" cy="14" r="11" fill="none" stroke={stroke} strokeWidth="2"
          strokeDasharray={CIRC} strokeDashoffset={arcOffset} strokeLinecap="round"
          transform="rotate(-90 14 14)" style={{ filter: glow }} />
        <text x="14" y="18" textAnchor="middle" fill={textFill} fontSize="8" fontFamily="ui-monospace" fontWeight="700">{letter}</text>
      </svg>
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <div style={{ fontSize: 8, letterSpacing: ".14em", textTransform: "uppercase", fontWeight: 700, color: isBrief ? "rgba(129,140,248,.75)" : "rgba(251,191,36,.75)" }}>{tag}</div>
        <div style={{ fontSize: 12, fontWeight: 900, letterSpacing: ".06em", lineHeight: 1, color: isBrief ? "rgba(165,180,252,.98)" : "rgba(253,186,116,.98)", textShadow: isBrief ? "0 0 10px rgba(99,102,241,.4)" : "0 0 10px rgba(245,158,11,.35)" }}>{label}</div>
      </div>
    </button>
  );
}